import React from "react";
import moment from "moment";

export default ({ publishDate }) => (
  <span>{moment(publishDate).format("LL")}</span>
);
